export const scrollTopWhenPageBeforeMount = () => {
  window.scrollTo(0, 0);
};
